package org.example.zone360.pages.dashboard.coaches.notifications

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleDown
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleUp
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleCheck
import com.varabyte.kobweb.silk.components.icons.fa.FaEllipsisVertical
import com.varabyte.kobweb.silk.components.icons.fa.FaHourglassHalf
import com.varabyte.kobweb.silk.components.icons.fa.FaSquarePollVertical
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomSpacer
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.NotificationsList
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.w3c.dom.Image

data class NotificationUiModel(
    val id: String,
    val senderName: String,
    val title: String,
    val message: String,
    val timeAgo: String,
    val isAdminRead: Boolean,
    val isUnread: Boolean,
    val isRead: Boolean,
    val showActions: Boolean,
    val sessionId: String?,
    val receiverId: String,
    val senderId: String,
    val sessionType: String,
    val category: String,
    val status: String?,
)

enum class NotificationFilter {
    ALL, ACTIONED, UN_ACTIONED
}


@Composable
fun NotificationsDropdown(
    notifications: List<NotificationUiModel>,
    onClose: () -> Unit,
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val isPlayer = AppGlobal.userData.role == Strings.PLAYER
    var selectedFilter by remember { mutableStateOf(NotificationFilter.ALL) }
    val filteredNotifications = when (selectedFilter) {
        NotificationFilter.ALL -> notifications

        NotificationFilter.ACTIONED -> notifications.filter { !it.sessionId.isNullOrBlank() }

        NotificationFilter.UN_ACTIONED -> notifications.filter { it.sessionId.isNullOrBlank() }
    }


    val breakpoint = rememberBreakpoint()
    val dropdownWidth = when {
        breakpoint >= Breakpoint.MD -> 405.px
        else -> 335.px
    }

    Box(
        modifier = Modifier.classNames("dropdown-menu").width(dropdownWidth)
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .border(1.px, LineStyle.Solid, sitePalette.textFieldBorderColor.rgb).borderRadius(15.px)
            .zIndex(9999)
    ) {

        Column(modifier = Modifier.fillMaxWidth()) {
            Box(
                modifier = Modifier.fillMaxWidth()
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb).margin(top = (-7).px)
                    .padding(topBottom = 18.px).borderRadius(topLeft = 12.px, topRight = 12.px)
                    .borderBottom(1.px, LineStyle.Solid, sitePalette.textFieldBorderColor.rgb)
                    .boxShadow(0.px, 2.px, 8.px, (-2).px, color = sitePalette.notificationBar.rgb)
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth()
                        .padding(leftRight = if (breakpoint < Breakpoint.MD) 10.px else 16.px),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FieldTitleTextNormalSimple(
                        text = "Notifications", fontSize = 16.px, fontWeight = 600
                    )
                    Row(
                        modifier = Modifier.fillMaxWidth(if (breakpoint < Breakpoint.MD) 66.percent else 80.percent)
                            .gap(if (breakpoint < Breakpoint.MD) 3.px else 10.px),
                        horizontalArrangement = Arrangement.End
                    ) {
                        CommonButton(
                            text = "All",
                            textColor = if (selectedFilter == NotificationFilter.ALL) sitePalette.bodyBackgroundSecondary.rgb
                            else sitePalette.textFieldTextColor.rgb,
                            backgroundColor = if (selectedFilter == NotificationFilter.ALL) sitePalette.primary.rgb
                            else sitePalette.lightGrey.rgb,
                            width = 40.px,
                            height = 28.px,
                            pointerCursor = true,
                            onCLick = { selectedFilter = NotificationFilter.ALL })

                        CommonButton(
                            text = "Actioned",
                            textColor = if (selectedFilter == NotificationFilter.ACTIONED) sitePalette.bodyBackgroundSecondary.rgb
                            else sitePalette.textFieldTextColor.rgb,
                            backgroundColor = if (selectedFilter == NotificationFilter.ACTIONED) sitePalette.primary.rgb
                            else sitePalette.lightGrey.rgb,
                            width = 70.px,
                            height = 28.px,
                            pointerCursor = true,
                            onCLick = { selectedFilter = NotificationFilter.ACTIONED })
                        if (!isPlayer) {
                            CommonButton(
                                text = "UnActioned",
                                textColor = if (selectedFilter == NotificationFilter.UN_ACTIONED) sitePalette.bodyBackgroundSecondary.rgb
                                else sitePalette.textFieldTextColor.rgb,
                                backgroundColor = if (selectedFilter == NotificationFilter.UN_ACTIONED) sitePalette.primary.rgb
                                else sitePalette.lightGrey.rgb,
                                width = 95.px,
                                height = 28.px,
                                pointerCursor = true,
                                onCLick = { selectedFilter = NotificationFilter.UN_ACTIONED })
                        }
                    }

                }
            }
            // Notification list
            if (filteredNotifications.isEmpty()) {
                Column(
                    modifier = Modifier.fillMaxWidth().maxHeight(535.px).minHeight(400.px)
                        .gap(15.px).overflow(Overflow.Auto)
                        .padding(leftRight = 15.px, topBottom = 10.px),
                    verticalArrangement = Arrangement.Center
                ) {
                    Box(
                        modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = "You don’t have any notifications yet",
                            fontSize = 16.px,
                            fontWeight = 500,
                        )
                    }
                }
            } else {
                Column(
                    modifier = Modifier.fillMaxWidth().maxHeight(535.px).minHeight(400.px)
                        .gap(15.px).overflow(Overflow.Auto)
                        .padding(leftRight = 15.px, topBottom = 10.px),
                ) {

                    filteredNotifications.forEach { item ->
                        NotificationRow(item)
                    }
                }
            }
        }
    }
}

    @Composable
    fun NotificationRow(item: NotificationUiModel) {
        val sitePalette = ColorMode.current.toSitePalette()
        var expanded by remember(item.id) { mutableStateOf(false) }
        val isPlayer = AppGlobal.userData.role == Strings.PLAYER
        val isExpandable = !item.sessionId.isNullOrBlank()
        val ctx = rememberPageContext()
        Box(
            modifier = Modifier.fillMaxWidth().padding(leftRight = 10.px)
                .backgroundColor(if (item.isRead) sitePalette.modalBackgroundColor.rgb else sitePalette.lightGrey.rgb)
                .borderRadius(12.px).cursor(if (isExpandable) Cursor.Pointer else Cursor.Default)
                .boxShadow(0.px, 2.px, 8.px, color = sitePalette.notificationBar.rgb)
        ) {

            Column(Modifier.fillMaxWidth().padding(12.px).gap(5.px)) {

                Row(
                    modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically
                ) {

                    Row(
                        modifier = Modifier.weight(1f), verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleTextNormalSimple(
                            text = item.title,
                            fontSize = 14.px,
                            fontWeight = 600,
                            wordBreak = WordBreak.BreakAll,
                            color = sitePalette.textFieldTextColor.rgb
                        )
                    }
                    if (item.sessionId.isNullOrBlank()) {
                        Image(
                            src = Res.Images.loading_gif,
                            alt = "Loading",
                            modifier = Modifier.size(32.px).margin(bottom = 3.px)
                        )
                    }
                }
                FieldTitleTextNormalSimple(
                    text = item.message,
                    fontSize = 12.5.px,
                    marginTop = (-2).px,
                    wordBreak = WordBreak.BreakAll,
                    color = sitePalette.textFieldTextColor.rgb,
                    marginBottom = 0.px,
                    onClick = {})
                if (!isPlayer) {
                    Div(
                        attrs = Modifier.fillMaxWidth().height(if (expanded) 105.px else 0.px)
                            .overflow(Overflow.Hidden).transition(
                                Transition.of(
                                    property = "height",
                                    duration = 300.ms,
                                    timingFunction = AnimationTimingFunction.EaseInOut
                                )
                            ).padding(top = if (expanded) 10.px else 0.px).toAttrs()
                    ) {
                        Column(Modifier.fillMaxWidth().gap(8.px)) {

                            SpanText(
                                text = if (item.status == "completed") "Please review the analysis details below to understand the outcome and next steps." else "The session has been recorded and is being processed. Please wait until the analysis is complete.",
                                modifier = Modifier.fontSize(12.px).color(Colors.Gray)
                            )
                            Row(modifier = Modifier.fillMaxWidth().gap(10.px)) {
                                FaCircleCheck(
                                    modifier = Modifier.color(if (item.status == "completed") Colors.Green else Colors.GoldenRod)
                                        .size(12.px), IconStyle.FILLED
                                )
                                SpanText(
                                    text = "Action has been taken",
                                    modifier = Modifier.fontSize(12.px)
                                        .color(if (item.status == "completed") Colors.Green else Colors.GoldenRod)
                                )
                            }
                            Row(
                                modifier = Modifier.fillMaxWidth().gap(10.px)
                                    .cursor(if (item.status == "completed") Cursor.Pointer else Cursor.Default)
                                    .onClick {
                                        when (item.category) {
                                            "request_assessment" -> {
                                                if (item.status == "completed") {
                                                    ctx.router.navigateTo(
                                                        "/player-details?userId=${item.senderId}"
                                                    )
                                                }
                                            }

                                            "analysis_completed" -> {
                                                if (item.sessionType == "player assessment") {
                                                    ctx.router.navigateTo(
                                                        "/player-details?userId=${item.senderId}"
                                                    )
                                                } else {
                                                    ctx.router.navigateTo("/coach-details?userId=${item.receiverId}&sessionId=${item.sessionId}&category=${if (item.sessionType == "match") "request_match" else "request_training"}")
                                                }
                                            }

                                            else -> {
                                                if (item.status == "completed") {
                                                    ctx.router.navigateTo(
                                                        "/coach-details?userId=${item.receiverId}&sessionId=${item.sessionId}&category=${item.category}"
                                                    )
                                                }
                                            }
                                        }
                                    }

                            ) {
                                FaSquarePollVertical(
                                    modifier = Modifier.color(if (item.status == "completed") sitePalette.primary.rgb else Colors.Gray)
                                        .size(12.px)
                                )
                                FieldTitleTextNormalSimple(
                                    text = if (item.status == "completed") "View Analysis" else "Waiting for analysis",
                                    width = 120.px,
                                    isClickable = true,
                                    onClick = {

                                    })
                            }
                        }
                    }
                }
                Row(
                    modifier = Modifier.fillMaxWidth().onClick {
                        if (isExpandable) expanded = !expanded
                    },
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    if (item.timeAgo.isNotBlank()) {
                        SpanText(
                            text = item.timeAgo, modifier = Modifier.fontSize(12.px).color(Colors.Gray)
                        )
                    }
                    if (!isPlayer) {
                        if (isExpandable) {
                            if (expanded) {
                                FaAngleUp(
                                    Modifier.margin(left = 8.px)
                                        .color(sitePalette.textFieldTextColor.rgb)
                                )
                            } else {
                                FaAngleDown(
                                    Modifier.margin(left = 8.px)
                                        .color(sitePalette.textFieldTextColor.rgb)
                                )
                            }
                        }
                    }
                }
            }
        }
    }


